import { ActionBrick, registerBrick, File, ErrorFlow } from 'olympe';
import hash from 'crypto-hash'

export default class HashFile extends ActionBrick {

    /**
     * @protected
     * @param {!BrickContext} context
     * @param {File} fileToHash
     * @param {string} hashMethod
     * @param {function()} forwardEvent
     * @param {function(string)} setHashgenerated
     */
    async update(context, [fileToHash, hashMethod], [forwardEvent, setHashgenerated]) {
        try {
            const content = await fileToHash.getContentAsBinary();
            if(hash[hashMethod.toLowerCase()] !== undefined){
                hash[hashMethod.toLowerCase()](content).then(hashValue => {
                    setHashgenerated(hashValue);
                    forwardEvent();
                });
            } else {
                console.error('The hash method is unrecognised', hashMethod.toLowerCase());
                setHashgenerated('');
                forwardEvent();
            }
        } catch (error) {
            throw ErrorFlow.create(`Failed to retrieve the file content: ${e.message}`, 1);
        }
    }
}

registerBrick('017a381492c854fb6ff8', HashFile);
